import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.875 0H2.5A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5-1.5V6.125H7.5a.625.625 0 0 1-.625-.625zm5.707 4.875L8.125.418v4.457z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceContentFile = { render };
export {
  interfaceContentFile as default,
  render
};
//# sourceMappingURL=interface-content-file.svg.js.map
